const createFakeWidget = () => ({
    execute() {
        return this;
    },
    get() {
        return Promise.resolve();
    },
});

module.exports = createFakeWidget();
